import { createStyles } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

/** Shared styles for the add-player sheet, its form body, and the small field/label
 *  helpers. Kept in one place so the sheet chrome and the form read consistently. */
export const useStyles = createStyles(({ scale, isTablet, deviceWidth, deviceHeight }) => ({
  sheet: {
    paddingTop: isTablet ? scale(16) : undefined,
    height: isTablet ? '100%' : '92%',
    borderTopLeftRadius: scale(20),
    borderTopRightRadius: scale(20),
  },
  title: {
    color: colors['10'],
  },
  // ---- Tablet popup (Figma: 512×700 centered card on the 1024×768 base) ----
  popupCenter: {},
  popupCard: {
    width: Math.min(scale(512), deviceWidth * 0.9),
    // Figma card is 700 tall; cap to the viewport on shorter windows so it never clips.
    height: Math.min(scale(700), deviceHeight * 0.9),
    backgroundColor: 'white',
    borderRadius: scale(16),
    paddingTop: scale(16),
    overflow: 'hidden',
  },
  popupTitle: {
    textAlign: 'center',
    marginBottom: scale(8),
    color: colors['10'],
  },
  popupFooter: {
    paddingHorizontal: scale(20),
    paddingTop: scale(4),
    paddingBottom: scale(16),
    borderTopColor: guardianColors[2],
    borderTopWidth: 1,
    gap: scale(12),
  },
  popupActions: {
    flexDirection: 'row',
    gap: scale(12),
    marginTop: scale(12),
  },
  popupActionsCenter: {
    justifyContent: 'center',
  },
  footerButton: {
    flex: 1,
    height: scale(48),
    borderRadius: scale(12),
  },
  // Single Close button in view mode: fixed width, NO `flex` (mixing `flex` with
  // an explicit width is unreliable in RN, which is why it collapsed before).
  viewCloseButton: {
    width: scale(232),
    borderRadius: scale(12),
  },
  body: {
    paddingHorizontal: scale(20),
    paddingTop: scale(8),
    paddingBottom: scale(24),
  },
  // Read-only "View player" summary card (shared PlayerProfileDetail).
  viewBody: {
    paddingHorizontal: scale(20),
    paddingTop: scale(8),
    paddingBottom: scale(24),
  },
  fieldLabel: {
    color: colors['10'],
  },
  fieldText: {
    color: colors['10'],
    marginLeft: 0,
  },
  fieldContent: {
    borderColor: colors['3'],
    borderRadius: scale(8),
    height: scale(48),
    paddingLeft: scale(12),
    paddingRight: scale(12),
    color: colors[10],
  },
  sectionHeader: {
    marginTop: scale(20),
    color: colors['10'],
  },
  asterisk: {
    color: colors.Red,
  },
  checkboxLabel: {
    color: colors['10'],
  },
  errorText: {
    marginTop: scale(2),
    color: colors.Error,
  },
  deleteButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: scale(8),
    marginTop: scale(24),
    marginBottom: scale(12),
  },
  deleteLabel: {
    color: guardianColors.Error,
  },
  keyboardAvoidingView: {
    flex: 1,
    width: '100%',
  },
}));
